import { FC } from "react";

import { Icon } from "shared/styles";
import { Button, LinkButton } from "shared/components";
import { ITheme } from "shared/types";
import { ChevronLeft } from "shared/assets/icons";
import { Spacer } from "shared/layout";

interface BackButtonProps {
  label: string;
  to?: string;
  onClick?: () => void;
}

export const BackButton: FC<BackButtonProps> = ({ to, label, onClick }) => {
  const renderContent = () => (
    <Spacer size="xxs" spaceDirection="horizontal" align="center">
      <Icon as={ChevronLeft} />
      <span>{label}</span>
    </Spacer>
  );

  return (
    <>
      {to && (
        <LinkButton to={to} size="s" theme={ITheme.secondary}>
          {renderContent()}
        </LinkButton>
      )}
      {onClick && (
        <Button onClick={onClick} size="s" theme={ITheme.secondary}>
          {renderContent()}
        </Button>
      )}
    </>
  );
};
